import React from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter } from '@ionic/react';

import '../../../../css/qavaApp.css';


export function ViewAttachement_ImageModal(props) {

    //alert('In ViewAttachement_ExpenseImageModal');
    //alert(props.openModal);
    //alert(props.data.paymentType);
    //alert(props.data.totalAmount);
    //alert(props.data.fileLocation);


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonGrid className='appHeader'>
                <IonRow>
                    <IonCol>
                        {props.data.paymentType}
                    </IonCol>
                    <IonCol>
                        {props.data.totalAmount}
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonGrid  class='appGridContent'>
                <IonRow>
                    <IonCol>
                        <IonImg src={props.data.fileLocation}></IonImg>
                    </IonCol>
                </IonRow>
            </IonGrid>
            <IonFooter className='modal_footer_button_center'>
                    <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}
